var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1110",
    cx: 8.00016,
    cy: 11.3332,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00012 5.99998V9.33331M2.88542 14H13.1149C14.2965 14 15.0434 12.7622 14.4696 11.7549L9.35484 2.77728C8.7644 1.74091 7.23593 1.74091 6.64549 2.77728L1.53074 11.7549C0.956899 12.7622 1.7038 14 2.88542 14Z",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgError);
export default __webpack_public_path__ + "static/media/msg_error.b8ae259753b3a05d47e11dc4c1d783f9.svg";
export { ForwardRef as ReactComponent };